<script>
import getSecret from "@utils/get-secret";
import Layout from "@layouts/main";
import PageHeader from "@components/page-header";
import BaseDataTableRowSelectGestion from "@components/BaseDataTableRowSelectGestion";
import {
  authComputed,
  euroCouponsTutorialMethods,
  euroCouponsCouponMethods,
} from "@state/helpers";

export default {
  name: "EuroCouponsCouponIndex",
  page: {
    title: "Coupon",
    meta: [{ name: "description", content: getSecret("DESCRIPTION") }],
  },
  components: {
    Layout,
    PageHeader,
    BaseDataTableRowSelectGestion,
    EuroCouponsCouponForm: () => import("@components/euro_coupons/coupon/Form"),
    EuroCouponsCouponDetail: () => import("@components/euro_coupons/coupon/Detail"),
    EuroCouponsCouponDelete: () => import("@components/euro_coupons/coupon/Delete"),
    EuroCouponsCouponApprove: () => import("@components/euro_coupons/coupon/Approve"),
    EuroCouponsCouponInactive: () => import("@components/euro_coupons/coupon/Inactive"),
    EuroCouponsCouponeError: () => import("@components/euro_coupons/coupon/Error"),
  },
  data() {
    return {
      title: this.$t("coupons"),
      items: [
        {
          text: this.$t("home"),
          href: "/",
        },
        {
          text: this.$t("coupons"),
          active: true,
        },
      ],
      tableHeaders: [],
      toUpdate: {},
      toDetail: {},
      toDelete: {},
      errors: {},
      toApprove: {},
      toInactive: {},
      showApprove: false,
      showInactive: false,
      showForm: false,
      showDetail: false,
      showDelete: false,
      showError: false,
      is_thirdparty_user: false,
      autogenerate: false,
      action: null,
      reloadSelected: Math.random(),
    };
  },

  computed: {
    ...authComputed,
  },

  beforeMount() {
    const _ = this;
    let user_info = _.currentSession.user.user_info;

    _.is_thirdparty_user = user_info.is_thirdparty_user;
    _.autogenerate = user_info.thirdparty_info
      ? user_info.thirdparty_info.autogenerate_coupons
      : false;

    this.tableHeaders = [];
    if (!_.is_thirdparty_user) {
      this.tableHeaders = [
        ...this.tableHeaders,
        ...[
          { key: "selected", label: this.$t("selected") },
          // { key: "cxc", label: this.$t("cxc") },
        ],
      ];
    }

    if (_.autogenerate || !_.is_thirdparty_user) {
      this.tableHeaders = [
        ...this.tableHeaders,
        ...[{ key: "code", label: this.$t("code") }],
      ];
    }

    if (!_.autogenerate || !_.is_thirdparty_user) {
      this.tableHeaders = [
        ...this.tableHeaders,
        ...[{ key: "beneficiary", label: this.$t("beneficiary") }],
      ];
    }

    this.tableHeaders = [
      ...this.tableHeaders,
      ...[
        {
          key: "value",
          label: this.$t("value"),
          formatter: (value) => {
            return this.$formatDollar(value);
          },
        },
        { key: "validity", label: this.$t("validity") },
        {
          key: "state",
          label: this.$t("state"),
          formatter: (value) => {
            return this.$t(value);
          },
        },
        // { key: "redemption_information", label: this.$t("redemption_information") },
        { key: "type_coupon", label: this.$t("type_coupon") },
        { key: "actions", label: this.$t("actions") },
      ],
    ];

    // if (!_.is_thirdparty_user) {
    //   this.tableHeaders = [...this.tableHeaders, ...[
    //     { key: 'CO', label: this.$t('CO') },
    //     { key: 'cash_register', label: this.$t('cash_register') },
    //   ]]
    // }
  },

  mounted() {
    this.setShowTutorial(true);
    if (
      this.currentSession.user.groups_detail.some((group) => group.name === "aliados")
    ) {
      this.autogenerate
        ? this.setTutorialUrl("bonos_juju")
        : this.setTutorialUrl("bonos");
    } else {
      this.setTutorialUrl("bonos_administrativos");
    }
  },

  destroyed() {
    this.setShowTutorial(false);
  },

  methods: {
    ...euroCouponsTutorialMethods,
    ...euroCouponsCouponMethods,

    myProvider(ctx) {
      let context = this;
      ctx = context.$table_params(ctx);
      ctx += `&state__in=revision,sent_failed`;
      const promise = context.fetchEuroCouponsCoupon(ctx);
      return promise
        .then((data) => {
          return data;
        })
        .catch((error) => {
          context.$axios_error_noty(error, context);
          console.log(error);
          return [];
        });
    },
    showErrorFunction(errors) {
      this.showError = true;
      this.errors = errors;
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-container fluid class="p-2">
      <b-row>
        <b-col>
          <!-- <b-card> -->
          <!-- <b-button
              variant="primary"
              size="sm"
              @click="()=>{showForm=true; toUpdate={}}"
            >
              <i class="fe-plus"></i> {{ $t('create') }}
            </b-button> -->

          <BaseDataTableRowSelectGestion
            ref="table"
            :drfprovider="myProvider"
            :tableheaders="tableHeaders"
            @showError="showErrorFunction"
            :reloadSelected="reloadSelected"
          >
            <template v-slot:cell(beneficiary)="row">
              <b-row>
                <b-col class="d-flex flex-column justify-content-center">
                  <p class="p-0 m-0 font-weight-bold" style="">
                    {{
                      row.item.beneficiary
                        ? $capitalizeWords(row.item.beneficiary.name)
                        : "-"
                    }}
                  </p>
                  <i class="p-0 m-0" style="white-space: nowrap">{{
                    row.item.beneficiary
                      ? `${row.item.beneficiary.document_type} ${row.item.beneficiary.document}`
                      : "-"
                  }}</i>
                </b-col>

                <b-col
                  v-if="row.item.beneficiary && row.item.beneficiary.euro_employee"
                  class="my-auto"
                >
                  <i
                    v-b-tooltip.hover="{
                      variant: 'primary',
                      placement: 'leftbottom',
                      title: $t('euro_employee'),
                    }"
                    class="fas fa-exclamation-circle text-primary"
                    style="font-size: 20px"
                  ></i>
                </b-col>
              </b-row>
            </template>
            <template v-slot:cell(redemption_information)="row">
              <b-row>
                <b-col class="d-flex flex-column justify-content-center">
                  <div v-if="row.item.redemption_date">
                    <p class="p-0 m-0">{{ $strfDatetime(row.item.redemption_date) }}</p>
                    <i class="p-0 m-0">{{
                      `${row.item["CO"]} - ${row.item.cash_register}`
                    }}</i>
                  </div>
                </b-col>
              </b-row>
            </template>
            <template v-slot:cell(type_coupon)="row">
              <p class="m-0 p-0">
                {{
                  row.item.type_coupon
                    ? row.item.type_coupon
                    : row.item.type_coupon_string
                }}
              </p>
            </template>
            <template v-slot:cell(validity)="row">
              <b-row>
                <b-col class="d-flex flex-column justify-content-center">
                  <p class="p-0 m-0"><span>Inicio:</span>{{ row.item.valid_from }}</p>
                  <p class="p-0 m-0"><span>Fin:</span>{{ row.item.expiration_date }}</p>
                </b-col>
              </b-row>
            </template>
            <template v-slot:cell(actions)="row">
              <b-button-group size="xs">
                <!-- <b-button
                  :id="`info-btn-${row.index}`"
                  v-b-tooltip.hover="{
                    variant: 'info',
                    placement: 'leftbottom',
                    title: $t('detail'),
                  }"
                  variant="btn-link text-info btn-transparent"
                  size="xs"
                  @click="
                    () => {
                      showDetail = true;
                      toDetail = row.item;
                    }
                  "
                >
                  <i class="fe-info fe-2x"></i>
                </b-button> -->

                <!-- <b-button
                  :id="`update-btn-${row.index}`"
                  v-b-tooltip.hover="{
                    variant: 'warning',
                    placement: 'leftbottom',
                    title: $t('edit'),
                  }"
                  variant="btn-link text-warning btn-transparent"
                  size="xs"
                  @click="
                    () => {
                      showForm = true;
                      toUpdate = row.item;
                    }
                  "
                >
                  <i class="fe-edit fe-2x"></i>
                </b-button> -->

                <!-- <b-button
                  :id="`delete-btn-${row.index}`"
                  v-b-tooltip.hover="{
                    variant: 'danger',
                    placement: 'leftbottom',
                    title: $t('delete'),
                  }"
                  variant="btn-link text-danger btn-transparent"
                  size="xs"
                  @click="
                    () => {
                      showDelete = true;
                      toDelete = row.item;
                    }
                  "
                >
                  <i class="fe-x fe-2x"></i>
                </b-button> -->
                <b-button
                  :id="`approve-btn-${row.index}`"
                  v-b-tooltip.hover="{
                    variant: 'success',
                    placement: 'leftbottom',
                    title: $t('Approve'),
                  }"
                  v-if="row.item.state == 'revision'"
                  variant="btn-link text-success btn-transparent"
                  size="xs"
                  @click="
                    () => {
                      showApprove = true;
                      toApprove = row.item;
                      action = 'approve';
                    }
                  "
                >
                  <i class="fe-check fe-2x"></i>
                </b-button>
                <b-button
                  v-if="row.item.state == 'revision'"
                  :id="`inactive-btn-${row.index}`"
                  v-b-tooltip.hover="{
                    variant: 'danger',
                    placement: 'leftbottom',
                    title: $t('Inactive'),
                  }"
                  variant="btn-link text-danger btn-transparent"
                  size="xs"
                  @click="
                    () => {
                      showInactive = true;
                      toInactive = row.item;
                    }
                  "
                >
                  <i class="fe-x fe-2x"></i>
                </b-button>
                <b-button
                  :id="`approve-btn-${row.index}`"
                  v-b-tooltip.hover="{
                    variant: 'success',
                    placement: 'leftbottom',
                    title: $t('Re-enviar'),
                  }"
                  v-if="row.item.state == 'sent_failed'"
                  variant="btn-link text-success btn-transparent"
                  size="xs"
                  @click="
                    () => {
                      showApprove = true;
                      toApprove = row.item;
                      action = 'send_messages';
                    }
                  "
                >
                  <i class="fe-phone fe-2x"></i>
                </b-button>
              </b-button-group>
            </template>
          </BaseDataTableRowSelectGestion>

          <!-- </b-card> -->
        </b-col>
      </b-row>
    </b-container>

    <!-- Detail modal -->
    <EuroCouponsCouponDetail
      v-if="showDetail"
      :instanceJson="toDetail || {}"
      :oncomplete="
        () => {
          showDetail = false;
          toDetail = {};
        }
      "
      :oncancel="
        () => {
          showDetail = false;
          toDetail = {};
        }
      "
    >
    </EuroCouponsCouponDetail>

    <EuroCouponsCouponForm
      v-if="showForm"
      :fullform="true"
      :instanceJson="toUpdate || {}"
      :oncomplete="
        () => {
          showForm = false;
          toUpdate = {};
          $refs.table.refresh();
        }
      "
      :oncancel="
        () => {
          showForm = false;
          toUpdate = {};
        }
      "
    >
    </EuroCouponsCouponForm>

    <EuroCouponsCouponDelete
      v-if="showDelete"
      :instanceJson="toDelete"
      :oncomplete="
        () => {
          showDelete = false;
          toDelete = {};
          $refs.table.refresh();
        }
      "
      :oncancel="
        () => {
          showDelete = false;
          toDelete = {};
        }
      "
    >
    </EuroCouponsCouponDelete>
    <EuroCouponsCouponApprove
      v-if="showApprove"
      :instanceJson="toApprove"
      :action="action"
      :oncomplete="
        () => {
          showApprove = false;
          toApprove = {};
          $refs.table.refresh();
        }
      "
      @showError="showErrorFunction"
      :oncancel="
        () => {
          showApprove = false;
          toApprove = {};
        }
      "
    >
    </EuroCouponsCouponApprove>
    <EuroCouponsCouponInactive
      v-if="showInactive"
      :instanceJson="toInactive"
      :oncomplete="
        () => {
          showInactive = false;
          toInactive = {};
          $refs.table.refresh();
        }
      "
      :oncancel="
        () => {
          showInactive = false;
          toInactive = {};
        }
      "
    >
    </EuroCouponsCouponInactive>
    <EuroCouponsCouponeError
      v-if="showError"
      :errors="errors"
      :oncomplete="
        () => {
          showError = false;
          $refs.table.refresh();
        }
      "
      :oncancel="
        () => {
          showError = false;
          $refs.table.refresh();
        }
      "
    ></EuroCouponsCouponeError>
  </Layout>
</template>
